import { FormActionType } from "models/actionTypes/formActionTypes";
import { ContextConstants } from "utils/constants";
import { FormContextState } from "models/propTypes/genericFormProps";

export const FormReducer = (state: FormContextState, action: FormActionType): FormContextState => {
  switch (action.type) {
    case ContextConstants.FormActions.SET_AUTOGENERATED_VALUES:
      return { ...state, autogeneratedValues: action.payload };
    default:
      return state;
  }
};
